import { Switch } from "@mui/material";

import { className } from "utils/strings";

import "./ToggleButton.scss";

export const ToggleButton = (props: {
  label?: string;
  checked: boolean;
  onChange: (state: boolean) => void;
  className?: string;
}): JSX.Element => {
  const onChange = () => {
    props.onChange(!props.checked);
  };

  return (
    <div className={className({
      "toggleButton": true,
      [props.className ?? ""]: true,
    })}>
      {props.label && <label>{props.label}</label>}

      <Switch
        className="mainButton"
        focusVisibleClassName=".Mui-focusVisible"
        checked={props.checked}
        onChange={onChange}
        disableRipple
      />
    </div>
  );
};
